export type QueryOptions = {
  keepPreviousData: boolean;
  refetchOnMount: boolean;
  refetchOnWindowFocus: boolean;
  cacheTime: number;
  staleTime: number;
};
export const queryOptions: QueryOptions = {
  keepPreviousData: true,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  cacheTime: Infinity,
  staleTime: 5000,
};
